import { c as _c } from "react/compiler-runtime";
import { logout as authLogout, isAuthenticated as checkAuth, getCurrentUser as getUser } from "@/lib/auth-utils";
import { useCallback } from "react";

/**
 * Unified authentication hook
 * Works for both SSO and Direct Auth methods
 */
export function useAuth() {
  const $ = _c(1);
  const logout = _temp;
  const isAuthenticated = _temp2;
  const getCurrentUser = _temp3;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      logout,
      isAuthenticated,
      getCurrentUser
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp3() {
  return getUser();
}
function _temp2() {
  return checkAuth();
}
function _temp() {
  authLogout();
}